import { useEffect, useState, useCallback } from "react";
import api from "../api";
import { Modal, KindBadge } from "./ui";

function Group({ group, type, onMerged }) {
  const [primary, setPrimary] = useState(group.items[0]?.id);
  const [busy, setBusy] = useState(false);
  const name = (x) => type === "aziende" ? (x.name || "(senza nome)") : `${x.first_name || ""} ${x.last_name || ""}`.trim() || "(senza nome)";

  const mergeAll = async () => {
    const others = group.items.filter((x) => x.id !== primary);
    if (!window.confirm(`Unisco ${others.length} doppion${others.length === 1 ? "e" : "i"} nella scheda "${name(group.items.find((x) => x.id === primary))}"?\nRecapiti, etichette e storico verranno conservati; i doppioni saranno eliminati.`)) return;
    setBusy(true);
    const url = type === "aziende" ? "/companies/merge" : "/persons/merge";
    const errors = [];
    for (const d of others) {
      try { await api.post(url, { primary_id: primary, duplicate_id: d.id }); }
      catch (e) { errors.push(`${name(d)}: ${e?.response?.data?.detail || e.message}`); }
    }
    setBusy(false);
    if (errors.length) alert("Alcune unioni non riuscite:\n" + errors.join("\n"));
    onMerged();
  };

  return (
    <div style={{ border: "1px solid var(--border)", borderRadius: 8, padding: "8px 12px", marginBottom: 8 }} data-testid={`dup-group-${type}`}>
      <div className="muted" style={{ fontSize: 12, marginBottom: 6 }}>{group.reason}: <strong>{group.key}</strong> — scegli la scheda da tenere:</div>
      {group.items.map((x) => (
        <label key={x.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "2px 0", cursor: "pointer" }}>
          <input type="radio" name={`prim-${group.items[0].id}`} checked={primary === x.id} onChange={() => setPrimary(x.id)} data-testid={`dup-primary-${x.id}`} />
          <strong>{name(x)}</strong>
          <KindBadge kind={x.kind} />
          <span className="muted">{[x.email, x.phone].filter(Boolean).join(" · ")}</span>
        </label>
      ))}
      <button className="btn sm primary" style={{ marginTop: 6 }} onClick={mergeAll} disabled={busy} data-testid="dup-merge-group">
        {busy ? "Unisco…" : `🧬 Unisci ${group.items.length - 1} doppion${group.items.length === 2 ? "e" : "i"} nella scheda scelta`}
      </button>
    </div>
  );
}

export default function DuplicatesScan({ onClose }) {
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    setData(null);
    api.get("/persons/duplicates-scan", { noCache: true }).then((r) => setData(r.data)).catch((e) => {
      alert("Scansione fallita: " + (e?.response?.data?.detail || e.message));
      onClose();
    });
  }, [onClose]);
  useEffect(() => { load(); }, [load]);

  const nP = data?.persons?.length || 0;
  const nC = data?.companies?.length || 0;

  return (
    <Modal title="🧬 Scansione doppioni anagrafica" onClose={onClose} wide>
      {!data ? (
        <p className="muted" data-testid="dup-scanning">🔍 Scansione di tutta l'anagrafica in corso…</p>
      ) : nP + nC === 0 ? (
        <p data-testid="dup-none">✅ Nessun doppione trovato: l'anagrafica è pulita.</p>
      ) : (
        <div data-testid="dup-results" style={{ maxHeight: "62vh", overflowY: "auto" }}>
          <p className="muted" style={{ fontSize: 13 }}>Trovati <strong>{nP}</strong> gruppi tra le persone e <strong>{nC}</strong> tra le aziende. Per ogni gruppo scegli la scheda da tenere: le altre verranno unite (recapiti e storico conservati).</p>
          {nP > 0 && <h4 style={{ margin: "10px 0 6px" }}>👤 Persone ({nP})</h4>}
          {(data.persons || []).map((g, i) => <Group key={"p" + i} group={g} type="persone" onMerged={load} />)}
          {nC > 0 && <h4 style={{ margin: "14px 0 6px" }}>🏢 Aziende ({nC})</h4>}
          {(data.companies || []).map((g, i) => <Group key={"c" + i} group={g} type="aziende" onMerged={load} />)}
        </div>
      )}
      <div className="modal-actions">
        <button className="btn" onClick={load} data-testid="dup-rescan">🔄 Riscansiona</button>
        <button className="btn primary" onClick={onClose}>Chiudi</button>
      </div>
    </Modal>
  );
}
